import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getOtpCodeStart } from '@redux/actions/campaignRegister/getOtpCode';

export const useGetOtp = () => {
  const dispatch = useDispatch();

  return useCallback(({ campaignId, phoneNumber }) => {
    const params = {
      campaignId: campaignId,
      phoneNumber: phoneNumber
    };

    dispatch(getOtpCodeStart(params));
  }, []);
};
